function parseRange(value) {
  if (typeof value === 'number') {
    return [value, Infinity]
  } else {
    return value
  }
}

/**
 * 自定义指令限制type=number的el-input组件，其数值处于指定范围内
 * - 当指令值为number时代表最小值
 * - 否则视为二元数组，指定最小值和最大值
 * - 指令修饰符int表示转换为整数，否则小数
 */
export const numberDirective = {
  mounted(el, binding) {
    const input = el.querySelector('.el-input__inner')
    if (!input) return

    const handler = (event) => {
      if (!event.isTrusted) return

      const value = binding.modifiers.int ? parseInt(input.value) : parseFloat(input.value)
      const range = parseRange(binding.value)

      if (Number.isNaN(value) || value < range[0]) {
        input.value = range[0]
      } else if (value > range[1]) {
        input.value = range[1]
      } else if (binding.modifiers.int ? input.value !== value : input.value != value) {
        input.value = value
      } else {
        return
      }

      const myEvent = new Event('input', { bubbles: true })
      input.dispatchEvent(myEvent) // 触发输入事件以更新v-model
    }

    input.addEventListener('input', handler)
    el.myhandler = handler
  },
  unmounted(el) {
    if (el.myhandler) {
      const input = el.querySelector('.el-input__inner')
      input.removeEventListener('input', el.myhandler)
    }
  }
}

export default { numberDirective }
